<script lang="ts">
  import type { Snippet } from 'svelte';
  import Footer from '$components/News/Footer/Footer.svelte';
  import SideRails from '$components/Common/SideRails.svelte';

  import { page } from '$app/state';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';
  interface Props {
    children?: Snippet;
  }

  let { children }: Props = $props();

  let brandReskinEnabled = $derived(flagValue(FEATURE_FLAGS.BRAND_RESKIN));
</script>

<div class:reskin={brandReskinEnabled}>
  {#if !brandReskinEnabled}
    <SideRails />
  {/if}
  {@render children?.()}
  <div class="footer">
    <Footer document={page.data.footer} />
  </div>
</div>

<style lang="scss">
  @import 'src/scss/variables';

  .reskin {
    background-color: $background-depth-0-color;
  }

  :not(.reskin) .footer {
    --theme-button-secondary-button-default-foreground-color: var(--twist-color-gray-100);
    --theme-button-secondary-button-active-foreground-color: var(--twist-color-gray-100);
    --theme-button-secondary-button-hover-focus-foreground-color: var(--twist-color-gray-100);
    --theme-button-secondary-button-default-background-color: var(--twist-color-gray-0);
    --theme-button-secondary-button-active-background-color: #e2e2e2;
    --theme-button-secondary-button-hover-focus-background-color: #e2e2e2;
  }
</style>
